var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container form-container" }, [
      _c("div", { staticClass: "row pb-3" }, [
        _c("div", { staticClass: "col-12 col-xl-4 mb-3" }, [
          _c("div", { staticClass: "clinical-trials-content" }, [
            _c("h2", { class: _vm.post_title_h_style }, [
              _vm._v(_vm._s(_vm.post_title)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.post_description) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-xl-8" },
          [
            _c("clinical-form", {
              on: {
                "before-search": _vm.beforeSearch,
                "search-results": _vm.onSearchResults,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid clip-path-ellipse-concave-square",
        attrs: { id: "clinical-trials-results-wrap" },
      },
      [
        _c("div", { staticClass: "container py-3" }, [
          _c(
            "div",
            { staticClass: "row vue-search-results" },
            [_c("clinical-results-heading", { attrs: { posts: _vm.posts } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row", attrs: { id: "clinical-trials-results" } },
            [
              _vm._l(_vm.currentPosts, function (post) {
                return _c("clinical-results", {
                  key: post["title"],
                  attrs: { post: post },
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  class: {
                    "d-none":
                      _vm.$store.state.results_count || !_vm.initialized,
                  },
                },
                [_vm._v(_vm._s(_vm.no_results_message))]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container py-2", class: { "d-none": _vm.has_more } },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showMoreCards()
                    },
                  },
                },
                [_vm._v("Load More Results")]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }